{
  "campaignName": "",
  "platform": "Symbiotic.fi",
  "description": "Points for providing liquidity.",
  "platformImageId": "symbiotic.png",
  "dashboardLink": "https://app.symbiotic.fi/dashboard",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x8c65cec3847ad99bdc02621bdbc89f2ace56934b",
      "network": "ethereum",
      "multiplier": "1x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xcec99cff3632cf1f16652cc5b1e80eb08be25983",
      "network": "ethereum",
      "multiplier": "1x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x73e4bec1a111869f395cbb24f6676826bf86d905",
      "network": "ethereum",
      "multiplier": "0-1x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
